import { render, staticRenderFns } from "./Comentaris.vue?vue&type=template&id=5d663a04&"
import script from "./Comentaris.vue?vue&type=script&lang=js&"
export * from "./Comentaris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports